import React from 'react'
import styled from 'styled-components'
import { View, Text } from '@olxbr/design-system'

import AlertSymbol from '../../atoms/AlertSymbol'
import Subtitle from '../../atoms/Subtitle'
import _Link from '../../atoms/Link'
import { fontH2 } from '../../../util/font'
import medias from '../../../util/medias'

const Content = styled(View)`
  width: 600px;
  padding: 64px;
  display: flex;
  flex-direction: row;
  background-color: #ffffff;
  ${medias.extraLarge`width: 100%;`}
  ${medias.extraLarge`padding: 32px 24px;`}
`

const Wrapper = styled(View)`
  margin-left: 36px;
`

const WrapperDescription = styled(View)`
  margin-top: 16px;
  max-width: 464px;
`

const Description = styled(Subtitle)`
  margin-top: 16px;
`

const Title = styled(Text)`
  ${fontH2};
  font-weight: 700;
`

const WrapperLink = styled(View)`
  display: flex;
  margin-top: 8px;
  align-items: flex-start;
`

const Link = styled(_Link)`
  font-size: 16px;
`

const LinkText = styled(Text)`
  font-size: 16px;
  color: #4a4a4a;
`

const VerifyEmailLinkExpired = ({ onMyAccountClick }) => (
  <Content>
    <AlertSymbol />
    <Wrapper>
      <Title>Link Expirado</Title>
      <WrapperDescription>
        <Description>O link para verificação da conta não é válido.</Description>
      </WrapperDescription>
      <WrapperLink>
        <LinkText>
          Vá para{' '}
          <Link type="primary" underline onClick={onMyAccountClick}>
            Meu Cadastro
          </Link>{' '}
          e reenvie o e-mail de verificação.
        </LinkText>
      </WrapperLink>
    </Wrapper>
  </Content>
)

export default VerifyEmailLinkExpired
